import React, { Component } from 'react';
import { connect } from 'react-redux';
import smoothScroll from 'smoothscroll';

import { setPageNumberDispatch } from '../actions';

class Pagination extends Component {
	constructor() {
		super();
	}

	componentWillUpdate( nextProps ) {
		this.totalPages = Math.ceil( parseInt( nextProps.totalCount ) / parseInt( nextProps.pageCount ) );
	}

	handlePaginationClick( event ) {
		event.preventDefault();
		let pageNum = (parseInt( event.target.getAttribute( 'data-pageNum' ) )
		              )
			? event.target.getAttribute( 'data-pageNum' )
			: parseInt( this.props.pageNum ) + 1;
		this.props.setPageNumberDispatch( pageNum );
	}

	handleNextClick( event ) {
		event.preventDefault();
		let pageNum = parseInt( this.props.pageNum ) + 1;
		this.props.setPageNumberDispatch( pageNum );
	}

	handlePrevClick( event ) {
		event.preventDefault();
		let pageNum = parseInt( this.props.pageNum ) - 1;
		this.props.setPageNumberDispatch( pageNum );
	}

	renderPreviousButton() {
		if ( 1 < parseInt( this.props.pageNum ) ) {
			return (<button type="button" className="page-numbers"
			                onClick={ this.handlePrevClick.bind( this ) }>
					<i className="fa-solid fa-chevron-left"></i><span
					className="sr-only">Previous</span>
				</button>
			);
		}
	}

	renderNextButton() {
		if ( (this.totalPages
		     ) > parseInt( this.props.pageNum ) ) {
			return (<button type="button" className="page-numbers"
			                onClick={ this.handleNextClick.bind( this ) }>
					<i className="fa-solid fa-chevron-right"></i><span
					className="sr-only">Next</span>
				</button>
			);
		}
	}

	renderPageNumbers() {
		let totalPages = Math.ceil( parseInt( this.props.totalCount ) / parseInt( this.props.pageCount ) );

		if ( 1 < totalPages ) {
			let pageNumbers = [ 1, 2, 3, 4, 5, 6 ]; // default
			if ( 6 > totalPages ) { // less than 6 pages
				pageNumbers = [];
				for ( var i = 1; i <= totalPages; i++ ) {
					pageNumbers.push( i );
				}
			} else if ( parseInt( this.props.pageNum ) > (totalPages - 6
				) ) { // less than 6 pages from the end
				pageNumbers = [];
				for ( var i = totalPages - 6; i <= totalPages; i++ ) {
					pageNumbers.push( i );
				}
			} else if ( 3 < parseInt( this.props.pageNum ) ) { // somewhere in the middle
				pageNumbers = [];
				for ( var i = (parseInt( this.props.pageNum ) - 2
				); i <= (parseInt( this.props.pageNum ) + 3
				); i++ ) {
					pageNumbers.push( i );
				}
			}

			return (pageNumbers.map( ind => {
					return (
						<button key={ ind } className={ (this.props.pageNum === ind
						                                )
							? 'page-numbers current'
							: 'page-numbers' } onClick={ this.handlePaginationClick.bind( this ) } data-pageNum={ ind }>{ ind }</button>
					);
				} )
			);
		}

	}

	componentDidUpdate() {
		let doc = document.documentElement,
		    top = (window.pageYOffset || doc.scrollTop
		          ) - (doc.clientTop || 0
		          );
		if ( 400 < top ) {
			smoothScroll( document.getElementById( 'MemberListElement' ) );
		}
	}

	render() {
		return (<nav aria-label="" className="pagination">
				{ this.renderPreviousButton() }
				{ this.renderPageNumbers() }
				{ this.renderNextButton() }
			</nav>
		);
	}
}

function mapStateToProps( { pageCount, pageNum } ) {
	return { pageCount, pageNum };
}

export default connect( mapStateToProps, { setPageNumberDispatch } )( Pagination );